import React from 'react';
import { NewRadio } from 'panamera-react-ui';
var css = {
  "radioBtn": "oalp-3cNf4",
  "label": "oalp-2OFBy",
  "button": "oalp-39vYK"
};
var InputRadioButton = function InputRadioButton(_ref) {
  var displayText = _ref.displayText,
    name = _ref.name,
    onClick = _ref.onClick,
    value = _ref.value,
    _ref$isChecked = _ref.isChecked,
    isChecked = _ref$isChecked === void 0 ? false : _ref$isChecked;
  return /*#__PURE__*/React.createElement("div", {
    className: css.radioBtn
  }, /*#__PURE__*/React.createElement(NewRadio, {
    className: css.button,
    size: 18,
    name: name,
    id: value,
    value: value,
    onClick: onClick,
    checked: isChecked
  }), /*#__PURE__*/React.createElement("label", {
    htmlFor: value,
    className: css.label
  }, displayText));
};
InputRadioButton.defaultProps = {
  onClick: function onClick() {
    return undefined;
  }
};
export default InputRadioButton;